import gql from 'graphql-tag';

const vstDashboardQuery = gql`
  query vstDashboard($tappyPurchaseId: Int!) {
    vstDashboard(tappyPurchaseId: $tappyPurchaseId) {
      eventData
    }
  }
`;

export default vstDashboardQuery;
